import {
  CLEAR_PROGRESS,
  UPDATE_FINISHED_TOPICS,
  UPDATE_PROGRESS,
  UPDATE_FINISHED_SUB_SECTION
} from "../actionTypes";

export const initialCurrentPosition = {
  en: { section: null, agilePath: "/app", waterfallPath: "/app" },
  sp: { section: null, agilePath: "/app", waterfallPath: "/app" },
  zh: { section: null, agilePath: "/app", waterfallPath: "/app" },
  fr: { section: null, agilePath: "/app", waterfallPath: "/app" },
  pt: { section: null, agilePath: "/app", waterfallPath: "/app" },
}

const INITIAL_STATE = {
  finishedSubTopics:[],
  finishedTopics: [],
  assessmentDone: false,
  termsAccepted: false,
  orientationDone: false,
  allTopicsFinished: false,
  currentPosition: initialCurrentPosition,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_PROGRESS:
      return { ...state, ...action.progress };
    case UPDATE_FINISHED_TOPICS:
      return {
        ...state,
        finishedTopics: action.topics,
      };
    case UPDATE_FINISHED_SUB_SECTION:
      return {
        ...state,
        finishedSubTopics: action.sections,
      };
    case CLEAR_PROGRESS:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
